export const ColumnsNumber = 3;
export const defaultOddKey = "1_-1";
export const defaultDropdownValues = ["11_-1", "2_0:1", "10_-1"];
export const feedRestrictions = [{ feedId1: 5, feedId2: 6 }];
export const modal = 'modalToggle';
export const navigate = 'navigate';
export const RegexConst = {
    email: "^(?=[A-Z0-9][A-Z0-9@._%+-]{5,253}$)[A-Z0-9._%+-]{1,64}@(?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8}[A-Z]{2,63}$",
    password: "^(?=.*[a-z]{1,})(?=.*[A-Z]{1,})(?=.*[0-9]{1,})(?=.*[~?_\-:@{}|^\\\/\ ]).{8,16}$",
    name: "^(([a-z]){2,24}\s)?([a-z]){2,24}$",
    message: "^(\s{0,}((((https?:\/\/)|(www\.)|(winners\.com\.lr\/))\S{0,100})|(?!(https?:\/\/)|(www\.)|(winners\.com\.lr\/))\S{0,25})\s{0,}){0,1}(\s{1,}(((((https?:\/\/)|(www\.)|(winners\.com\.lr\/))\S{0,100})|(?!(https?:\/\/)|(www\.)|(winners\.com\.lr\/))\S{0,25}|((?=[A-Z0-9][A-Z0-9@._%+-]{5,253}$)[A-Z0-9._%+-]{1,64}@(?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8}[A-Z]{2,63})\s{0,}))){0,200}$",
}